export enum Routes {
  DASHBOARD = 'dashboard',
  FEEDBACK = 'feedback',
  APPOINTMENTS = 'appointments',
  APPOINTMENT = 'appointment',
  CONFIRMATION = 'confirmation',
  ASSESSMENT_REPORT = 'assessment-report',
  ASSESSMENT = 'assessment',
  PAY = 'records/pay',
  LATEST_RECORD = 'records/latest',
  RECORDS = 'records',
  PURCHASE = 'purchase',
  LOGIN = 'login',
  LOGOUT = 'logout',
  HMS = 'meet',
  INHOUSE_MEET = 'inhouse-meet',
  REDIRECT = 'redirect',
  RESOURCES = 'resources',
  AUTHORIZE = 'authorize',
  PREPORT = 'prescription-report',
  REPORT = 'report',
  PRINT_PRESCRIPTION = 'print-prescription',
  PROFILE = 'profile',
  MEDICINES = 'medicines',
  MEDICINES_CONFIRM = 'medicines/select-address/confirm',
  LAB_TESTS = 'lab-tests',
  INBOX = 'inbox',
  WAITING = 'waiting-screen',
}
